import PassResultType from "../../../../../sports/football/enums/pass-result-type";
import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class SpikeFragmentSerializer extends FragmentSerializer {
    getRawFragment(play, serializationContext, spike) {
        let values = [
            this.resolveUniform(serializationContext, spike.spikedBy),
            PassResultType.INCOMPLETE.code,
            "TM",
            "*"
        ];

        return `PASS:${values.join()}`;
    }

    applicable(fragment) {
        return fragment.associatedState === FootballState.Spike;
    }
}
